import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ValidatorInput } from '../model.module/validation/validation-descriptor.entity';

@Component({
    selector: 'elem-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextareaComponent implements OnInit {

    readonly linebreakRegex = /\r?\n|\r/g;

    @ViewChild('textAreaElement', { static: false })
    textAreaElement: ElementRef;

    @Input()
    inputElemId: string;

    @Input()
    inputElemName: string;

    @Input()
    placeholder: string;

    @Input()
    required = false;

    @Input()
    allowLineBreaks = true;

    @Input()
    fieldModel: ValidatorInput;

    @Input()
    maxLength: string;

    @Output()
    blur = new EventEmitter<FocusEvent>();

    constructor() {
    }

    ngOnInit(): void {
    }

    onInputFieldBlur(event: any) {
        this.blur.emit(event);
    }

    onInputFieldKeyDown($event: KeyboardEvent) {
        // Sofern konfiguiert, lasse keine Zeilenumbrüche zu
        if (!this.allowLineBreaks && $event.key === 'Enter') {
            $event.preventDefault();
            $event.stopPropagation();
        }
    }

    onInputFieldKeyUp() {
        // Sofern konfiguriert, lasse keine Zeilenumbrüche für eingefügte Copy-Paste-Werte zu
        if (!this.allowLineBreaks) {
            this.fieldModel.value = (this.fieldModel.value as string).replace(this.linebreakRegex, ' ');
        }
    }
}
